import App from '@/models/App'

export default class ShipVoyageNo extends App {
    static get entity() {
        return 'ShipVoyageNos'
    }
    static latestByShipId(shipId) {
        return this.query()
            .where('shipId', shipId)
            .withAllRecursive()
            .orderBy('voyageNo', 'desc')
            .first()
    }
    static fetchByShipId(shipId) {
        return this.query()
            .where('shipId', shipId)
            .withAllRecursive()
            .orderBy('voyageNo', 'desc')
            .get()
    }
    static fields() {
        return {
            id: this.attr(''),
            shipId: this.attr(''),
            voyageNo: this.attr(0),
        }
    }
    static apiConfig = {
        actions: {
            fetch(shipId, voyageNo) {
                return this.get(`${shipId}/voyages/number`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
        },
    }
}
